// /js/partials/filters-bar.js
"use strict";

import { onReady } from '../core/ready.js';

function initFiltersBar() {
    const filtersBar = document.querySelector("#catalogFiltersBar");
    const filtersCollapse = document.getElementById('filtersCollapse');
    if (!filtersBar || !filtersCollapse) return;
    const filtersCollapseBody = filtersCollapse.querySelector('.filters-collapse-body');

    // Permette lo scroll nativo del pannello filtri quando Lenis è attivo.
    if (!filtersCollapse.hasAttribute('data-lenis-prevent')) {
        filtersCollapse.setAttribute('data-lenis-prevent', '');
    }
    if (filtersCollapseBody && !filtersCollapseBody.hasAttribute('data-lenis-prevent')) {
        filtersCollapseBody.setAttribute('data-lenis-prevent', '');
    }

    const navbar = document.querySelector('#pageHeader');

    let isSticky = false;
    let navbarHeight = (navbar && navbar.offsetHeight) || 0;
    let threshold = window.innerHeight / 2;

    function recalc() {
        navbarHeight = (navbar && navbar.offsetHeight) || 0;
        threshold = window.innerHeight / 2;
        if (isSticky && window.gsap) window.gsap.set(filtersBar, { y: navbarHeight });
    }

    function showFiltersBar() {
        if (!filtersBar || isSticky) return;
        filtersBar.classList.add("sticky");
        (window.gsap || { fromTo: () => {} }).fromTo(
            filtersBar,
            { y: -100, opacity: 0 },
            { y: navbarHeight, opacity: 1, duration: 0.5, ease: "power2.in" }
        );
        isSticky = true;
    }

    function hideFiltersBar() {
        if (!filtersBar || !isSticky) return;
        (window.gsap || { to: () => {} }).to(filtersBar, {
            y: 0,
            opacity: 1,
            duration: 0.5,
            ease: "power2.in",
            onComplete: () => filtersBar.classList.remove("sticky")
        });
        isSticky = false;
    }

    function handleScrollForFiltersBar() {
        const scrollY = window.scrollY;
        if (scrollY > threshold) showFiltersBar();
        else hideFiltersBar();
    }

    // Bind scroll/resize una sola volta per elemento
    if (!filtersBar.dataset.scrollBound) {
        window.addEventListener("scroll", handleScrollForFiltersBar);
        window.addEventListener("resize", recalc);
        filtersBar.dataset.scrollBound = '1';
    }

    // Bootstrap collapse events (una sola volta)
    if (!filtersCollapse.dataset.bsBound) {
        filtersCollapse.addEventListener('show.bs.collapse', () => {
            document.body.classList.add('no-scroll', 'filters-open');
        });

        filtersCollapse.addEventListener('hidden.bs.collapse', () => {
            document.body.classList.remove('filters-open');
            if (!document.body.classList.contains('menu-open')) {
                document.body.classList.remove('no-scroll');
            }
        });
        
        filtersCollapse.dataset.bsBound = '1';
    }

    // Forza la chiusura del collapse da ogni bottone di chiusura (desktop/mobile)
    const closeCollapseBtns = filtersCollapse.querySelectorAll('.close-filter-collapse');
    closeCollapseBtns.forEach((btn) => {
        if (btn.dataset.bound) return;
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            window.bootstrap.Collapse.getInstance(filtersCollapse).hide();
        });
        btn.dataset.bound = '1';
    });

    const foot = filtersCollapse.querySelector('.filters-collapse-foot');
    const footStartContainer = foot ? foot.querySelector('.foot-start > .container') : null;
    const footEnd = foot ? foot.querySelector('.foot-end') : null;
    const footTitle = footStartContainer ? footStartContainer.querySelector('.filters-list-title') : null;
    const counter = footStartContainer ? footStartContainer.querySelector('#catalogResultsCounter') : null;
    const removeBtn = footStartContainer ? footStartContainer.querySelector('#removeCatalogFiltersBtn') : null;
    const closeMobileBtn = footStartContainer ? footStartContainer.querySelector('.close-filter-collapse-mobile') : null;
    const mobileActionsMq = window.matchMedia('(max-width: 767.98px)');

    let footActionsAnchor = null;
    if (footStartContainer && footTitle) {
        footActionsAnchor = footStartContainer.querySelector('[data-foot-actions-anchor]');
        if (!footActionsAnchor) {
            footActionsAnchor = document.createElement('span');
            footActionsAnchor.setAttribute('data-foot-actions-anchor', '1');
            footActionsAnchor.hidden = true;
            footTitle.insertAdjacentElement('afterend', footActionsAnchor);
        }
    }

    const ensureMobileActionsContainer = () => {
        if (!foot) return null;
        let mobileActions = foot.querySelector('.filters-mobile-actions');
        if (!mobileActions) {
            mobileActions = document.createElement('div');
            mobileActions.className = 'filters-mobile-actions';
            const inner = document.createElement('div');
            inner.className = 'container';
            mobileActions.appendChild(inner);
            foot.appendChild(mobileActions);
        }
        return mobileActions.querySelector('.container');
    };

    const syncMobileActionsPlacement = () => {
        if (!foot || !footStartContainer || !footEnd || !counter || !removeBtn || !closeMobileBtn || !footActionsAnchor) return;

        if (mobileActionsMq.matches) {
            const mobileActionsContainer = ensureMobileActionsContainer();
            const mobileActions = foot.querySelector('.filters-mobile-actions');
            if (!mobileActionsContainer || !mobileActions) return;

            if (footEnd.nextElementSibling !== mobileActions) {
                foot.insertBefore(mobileActions, footEnd.nextSibling);
            }

            if (counter.parentElement !== mobileActionsContainer) mobileActionsContainer.appendChild(counter);
            if (removeBtn.parentElement !== mobileActionsContainer) mobileActionsContainer.appendChild(removeBtn);
            if (closeMobileBtn.parentElement !== mobileActionsContainer) mobileActionsContainer.appendChild(closeMobileBtn);
            return;
        }

        if (counter.parentElement !== footStartContainer) footStartContainer.insertBefore(counter, footActionsAnchor);
        if (removeBtn.parentElement !== footStartContainer) footStartContainer.insertBefore(removeBtn, footActionsAnchor);
        if (closeMobileBtn.parentElement !== footStartContainer) footStartContainer.insertBefore(closeMobileBtn, footActionsAnchor);

        const mobileActions = foot.querySelector('.filters-mobile-actions');
        if (mobileActions) {
            mobileActions.remove();
        }
    };

    syncMobileActionsPlacement();
    if (!filtersCollapse.dataset.mobileActionsBound) {
        mobileActionsMq.addEventListener('change', syncMobileActionsPlacement);
        filtersCollapse.dataset.mobileActionsBound = '1';
    }

    // EcoFriendly featured <-> EcoFriendly: sync bidirezionale
    const checkEcoFriendly = document.getElementById('checkEcoFriendly');
    const checkEcoFriendlyFeatured = document.getElementById('checkEcoFriendlyFeatured');
    let isSyncingEcoFriendly = false;

    if (checkEcoFriendlyFeatured && checkEcoFriendly) {
        if (!checkEcoFriendlyFeatured.dataset.bound) {
            checkEcoFriendlyFeatured.addEventListener('change', () => {
                if (isSyncingEcoFriendly) return;
                isSyncingEcoFriendly = true;
                if (checkEcoFriendly.checked !== checkEcoFriendlyFeatured.checked) {
                    checkEcoFriendly.checked = checkEcoFriendlyFeatured.checked;
                    checkEcoFriendly.dispatchEvent(new Event('change', { bubbles: true }));
                }
                isSyncingEcoFriendly = false;
            });
            checkEcoFriendlyFeatured.dataset.bound = '1';
        }

        if (!checkEcoFriendly.dataset.syncBound) {
            checkEcoFriendly.addEventListener('change', () => {
                if (isSyncingEcoFriendly) return;
                isSyncingEcoFriendly = true;
                if (checkEcoFriendlyFeatured.checked !== checkEcoFriendly.checked) {
                    checkEcoFriendlyFeatured.checked = checkEcoFriendly.checked;
                }
                isSyncingEcoFriendly = false;
            });
            checkEcoFriendly.dataset.syncBound = '1';
        }

        if (checkEcoFriendlyFeatured.checked !== checkEcoFriendly.checked) {
            checkEcoFriendlyFeatured.checked = checkEcoFriendly.checked;
        }
    } else if (checkEcoFriendlyFeatured && !checkEcoFriendlyFeatured.dataset.bound) {
        checkEcoFriendlyFeatured.addEventListener('change', () => {
            const ecoInput = document.getElementById('checkEcoFriendly');
            if (ecoInput) {
                ecoInput.checked = checkEcoFriendlyFeatured.checked;
                ecoInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
        checkEcoFriendlyFeatured.dataset.bound = '1';
    }

    // Recalc iniziale
    recalc();
}

onReady(initFiltersBar);
